module.exports = __webpack_public_path__ + "img/seabay-logo.c64a23a0.png";